var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.user.permissions.indexOf(_vm.permissionsAll.product_list) >= 0 ||
      _vm.user.person.types_person.id === 3
  )?_c('div',[_c('CardProducts')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }